import React from 'react';
import SessionError from "./SessionError";

function Restricted() {
    return (
        <div className=" d-flex">
            <SessionError />
        </div>
    );
}

export default Restricted;